import script from "./StoryCheckboxInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoryCheckboxInput.vue?vue&type=script&lang=ts&setup=true"

import "./StoryCheckboxInput.vue?vue&type=style&index=0&id=d0b199a0&lang=scss"

const __exports__ = script;

export default __exports__